module.exports = __webpack_public_path__ + "img/_menu_vert_hover.d7738a39.svg";